import { render, staticRenderFns } from "./DetalleFichaje.vue?vue&type=template&id=163173bf&"
import script from "./DetalleFichaje.vue?vue&type=script&lang=js&"
export * from "./DetalleFichaje.vue?vue&type=script&lang=js&"
import style0 from "./DetalleFichaje.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports